import { useIsDesktop } from '@/_hooks/useBreakpoint';

import TimeDesktop from './desktop';
import TimeMobile from './mobile';
import { IWorkHour } from '@/_types';

interface TimeProps {
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  showTrigger?: boolean;
  interval: number;
  onConfirm: (time: string) => void;
  scheduleData?: { working_hours: IWorkHour[] };
  formattedTime: string;
}

export default function Time({
  open,
  onOpen,
  onClose,
  showTrigger = true,
  interval,
  onConfirm,
  scheduleData,
  formattedTime,
}: TimeProps) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return (
      <TimeDesktop
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        interval={interval}
        onConfirm={onConfirm}
        showTrigger={showTrigger}
        scheduleData={scheduleData}
        formattedTime={formattedTime}
      />
    );
  }
  return (
    <TimeMobile
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      interval={interval}
      onConfirm={onConfirm}
      showTrigger={showTrigger}
      scheduleData={scheduleData}
      formattedTime={formattedTime}
    />
  );
}
